import { useEffect, useState } from "react";
import {
  GALLERY_ALBUMS,
  GALLERY_CATEGORY_SLUG,
  WP_FILTER_SLUGS,
} from "@/data/gallery";
import { WP_API_URL } from "@/data/siteContent";

const decode = (html) => {
  const t = document.createElement("textarea");
  t.innerHTML = html;
  return t.value;
};

const extractPhotos = (html, fallbackTitle) => {
  const photos = [];
  const re = /<img[^>]*>/gi;
  let m;
  while ((m = re.exec(html)) !== null) {
    const src = (m[0].match(/src=["']([^"']+)["']/i) || [])[1];
    if (!src) continue;
    const alt = (m[0].match(/alt=["']([^"']*)["']/i) || [])[1] || "";
    photos.push({ src, title: decode(alt) || fallbackTitle });
  }
  return photos;
};

export const useGalleryAlbums = () => {
  const [albums, setAlbums] = useState(GALLERY_ALBUMS);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const catRes = await fetch(`${WP_API_URL}/categories?slug=${GALLERY_CATEGORY_SLUG}`);
        const cats = await catRes.json();
        if (!Array.isArray(cats) || cats.length === 0) return;
        const parentId = cats[0].id;

        const childRes = await fetch(`${WP_API_URL}/categories?parent=${parentId}&per_page=100`);
        const children = await childRes.json();
        const childMap = {};
        (Array.isArray(children) ? children : []).forEach((c) => {
          childMap[c.id] = c.slug;
        });

        const postRes = await fetch(
          `${WP_API_URL}/posts?categories=${parentId}&_embed=1&per_page=100`
        );
        const posts = await postRes.json();
        if (!Array.isArray(posts) || posts.length === 0) return;

        const wpAlbums = posts
          .map((post) => {
            const title = decode(post.title?.rendered || "Event Album");
            const photos = extractPhotos(post.content?.rendered || "", title);
            const cover =
              post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || photos[0]?.src;
            const childSlug = (post.categories || [])
              .map((id) => childMap[id])
              .find((slug) => slug && WP_FILTER_SLUGS[slug]);
            return {
              id: `wp-${post.id}`,
              title,
              category: childSlug ? WP_FILTER_SLUGS[childSlug] : "other",
              cover,
              photos,
            };
          })
          .filter((a) => a.cover && a.photos.length > 0);

        if (!cancelled && wpAlbums.length > 0) setAlbums(wpAlbums);
      } catch (e) {
        // WordPress not set up yet — bundled albums remain
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { albums };
};
